import { ApiBaseFront } from "../../front/api-base-front";

type Params = {
  kijshopCd: string,
  favProductId: string,
  name: string,
  folderId: string,
  level: number,
  indexes: number,
};

export class ApiPrintFavoriteProductEdit extends ApiBaseFront<{}> {
  constructor(param: Params) {
    const {
      kijshopCd,
      favProductId,
      ..._param
    } = param;

    super(
      'POST',
      `/api/v1/print/shop/${kijshopCd}/favProduct/${favProductId}`,
      'JSON',
      _param,
    );
  }
}
